import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { MdcOffline, MdcOfflineSync } from '../shared/mdc/mdc.model';
import { MdcService } from '../shared/mdc/mdc.service';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SqlliteDbService } from '../shared/sqlite/sqllite-db.service';
import { firstValueFrom } from 'rxjs';
import { UserAtividadeService } from '../shared/user-atividade/user-atividade.service';

declare var $: any;
declare var NioApp: any, Swal: any;
@Component({
  selector: 'app-form-offline',
  templateUrl: './form-offline.component.html'
})
export class FormOfflineComponent implements OnInit, AfterViewInit {

  p: number = 1;
  p2: number = 1;
  p3: number = 1;
  //
  itemsPerPage: number = 10;
  itemsPerPage2: number = 10;
  itemsPerPage3: number = 10;
  //
  isSyncing = false;
  isSyncingAll = false;

  syncStatus = {
    pending: 0,
    lastSync: null as Date | null
  };
  isVisivel = false;
  mdcList: MdcOffline[] = [];
  mdcOfflineSync: MdcOfflineSync[] = [];

  constructor(public authService: AuthService,
    public mdcService: MdcService,
    private router: Router,
    private renderer: Renderer2,
    public userAtividadeService: UserAtividadeService,
    private sqliteService: SqlliteDbService) { }

  showAside = false;

  toggleAside(): void {
    this.showAside = !this.showAside;
  }

  async ngOnInit() {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }

    const email = this.authService.getEmail();
    if (email !== null) {
      this.userAtividadeService.getUserActivity(email).subscribe({
        error: err => {
          if (err.status === 401) {
            this.authService.showSessionExpiredAlert();
          }
        }
      });
    }

    if (Capacitor.getPlatform() !== 'web') {
      this.isVisivel = true
      const initialized = await this.sqliteService.initializeOpenConnection();
      if (initialized) {
        const pendentes = await this.sqliteService.carregarQuestionariosOffline();
        this.mdcList = pendentes;

        //#region Para efeito de verificação
        const all = await this.sqliteService.carregarTodosOsQuestionariosOffline();
        this.mdcOfflineSync = all;
        //#endregion

      } else {
        console.warn('Falha na inicialização do SQLite.');
      }
    } else {
      this.mdcService.getFromLocalStorageList().subscribe((list: MdcOffline[]) => {
        this.mdcList = list;
      });
    }
  }

  ngAfterViewInit(): void {
    const toggleElements = document.querySelectorAll('[data-toggle-body="true"]');

    toggleElements.forEach(element => {
      const target = element.getAttribute('data-content');
      const toggleButton = document.querySelector(`[data-target="${target}"]`);

      if (toggleButton) {
        this.renderer.listen(toggleButton, 'click', () => {
          const body = document.body;
          if (body.classList.contains(`${target}-shown`)) {
            this.renderer.removeClass(body, `${target}-shown`);
          } else {
            this.renderer.addClass(body, `${target}-shown`);
          }
        });
      }
    });
  }

  async onSync() {

    if (this.isSyncing) {
      return;
    }

    try {

      this.isSyncing = true;

      if (Capacitor.getPlatform() !== 'web') {
        const pendentes = await this.sqliteService.carregarQuestionariosOffline();

        if (pendentes.length === 0) {
          alert('Nenhum dado pendente para sincronizar');
          this.isSyncing = false;
          return;
        }

        let sucesso = 0;
        for (const item of pendentes) {

          const submit = await firstValueFrom(this.mdcService.submitOffline(item));

          if (submit) {
            await this.sqliteService.marcarComoSincronizado(item.id);
            sucesso++;
          }
        }

        alert(`${sucesso} de ${pendentes.length} questionários sincronizados com sucesso!`);
        this.updateSyncStatus();
        window.location.reload();

      } else {
        this.mdcService.submitFromLocalStorageList();
      }
    } catch (error) {
      console.error('Erro na sincronização:', error);
      alert('Erro durante a sincronização. Tente novamente.');
      this.isSyncing = false;
    }
  }

  private async updateSyncStatus() {
    this.syncStatus.pending = await this.sqliteService.getTotalPendentes();
    this.syncStatus.lastSync = new Date();
  }

  async confirmarRemocao(id: number): Promise<void> {

    if (Capacitor.getPlatform() !== 'web') {

      const initialized = await this.sqliteService.initializeOpenConnection();
      if (initialized) {

        const questionario = await this.sqliteService.getQuestionarioOfflineById(id);

        if (!questionario) {
          Swal.fire('Erro', 'Questionário não encontrado.', 'error');
          return;
        }

        Swal.fire({
          title: 'Tem a certeza?',
          text: 'Deseja remover este questionário offline?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, remover',
          cancelButtonText: 'Cancelar'
          // @ts-ignore
        }).then(async (result) => {
          if (result.isConfirmed) {
            const sucesso = await this.sqliteService.removerQuestionarioOfflinePorId(id);
            if (sucesso) {
              Swal.fire('Removido!', 'O questionário foi removido com sucesso.', 'success');
              this.mdcList = await this.sqliteService.carregarQuestionariosOffline();
            } else {
              Swal.fire('Erro', 'Ocorreu um erro ao remover.', 'error');
            }
          }
        });
      } else {
        console.warn('Falha na inicialização do SQLite.');
      }
    } else {
      Swal.fire('Aviso!', 'Funcionalidade disponível apenas na versão mobile.', 'warning');
    }
  }

  async verDetalhesJson(id: number): Promise<void> {


    if (Capacitor.getPlatform() !== 'web') {

      const initialized = await this.sqliteService.initializeOpenConnection();

      if (initialized) {
        const questionario = await this.sqliteService.getQuestionarioOfflineById(id);

        if (!questionario) {
          Swal.fire('Erro', 'Questionário não encontrado.', 'error');
          return;
        }

        const json = JSON.stringify(questionario.mdc, null, 2);

        Swal.fire({
          title: 'Dados do Questionário',
          html: `<pre style="text-align:left; background:#f4f4f4; padding:10px; border-radius:5px;">${this.escapeHtml(json)}</pre>`,
          width: 800,
          confirmButtonText: 'Fechar',
          showCloseButton: true,
          closeButtonText: `<i class="fa-solid fa-xmark"></i>`,
          customClass: {
            popup: 'json-popup'
          }
        });

      } else {
        console.warn('Falha na inicialização do SQLite.');
      }

    } else {
      Swal.fire('Aviso!', 'Funcionalidade disponível apenas na versão mobile.', 'warning');
    }
  }

  escapeHtml(text: string): string {
    const map: { [key: string]: string } = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

  //#region Para efeito de verificação
  async onSyncAll() {

    if (this.isSyncingAll) {
      return;
    }

    try {

      this.isSyncingAll = true;

      if (Capacitor.getPlatform() !== 'web') {

        const pendentes = await this.sqliteService.carregarTodosOsQuestionariosOffline();

        if (pendentes.length === 0) {
          alert('Nenhum dado pendente para sincronizar');
          this.isSyncingAll = false;
          return;
        }

        this.mdcService.enviarQuestionarios(pendentes).subscribe({
          next: res => {
            alert(`${pendentes.length} questionários sincronizados com sucesso!`);
            window.location.reload();
          },
          error: err => {
            alert(`Falha ao sincronizar!`);
          }
        });

      } else {
        this.mdcService.submitFromLocalStorageList();
      }

    } catch (error) {
      console.error('Erro na sincronização:', error);
      alert('Erro durante a sincronização. Tente novamente.');
      this.isSyncingAll = false;
    }
  }
  //#endregion
}
